import React from 'react'
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");
  if (!token) return <Navigate to="/login" />;
  const affiliateRoutes = [ "/", "/affiliate-orders" ];
  if (userType === 'affiliate') {
    const path = window.location.pathname;
    if ( affiliateRoutes.find(route => path === route) === undefined) return <Navigate to="/" />;
  }
  return children;
};

export default PrivateRoute
